import React, { useState } from 'react'
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { breakpoints } from '~styles/global'
import { Darr } from '~components/Svg'
import RichText from '~components/RichText'

const FAQItem = ({ question, answer, className }) => {

  const [open, setOpen] = useState(false)   
  const { mobile } = breakpoints

  return (
    <div className={className} css={css`
        margin-bottom: 3rem;
    `}>
        <button 
            onClick={() => setOpen(!open)}
            css={css`
            letter-spacing: 0.03em;
            display: grid;
            grid-template-columns: min-content 1fr;
            align-items: center;
            text-align: left;
            margin-bottom: ${ open ? `2rem` : `0rem` };
            ${mobile} {
                margin-right: 3px;
            }
        `}>
            <div css={css`
                width: 24px;
                height: 24px;
                border-radius: 100px;
                background-color: var(--purple);
                display: grid;
                align-items: center;
                justify-content: center;
                margin-right: 2rem;
            `}>
              <Darr css={css`
                  width: 10px;
                  transform: ${ open ? `rotate(180deg)` : `none` };
              `}/>
            </div>
            <span>{question}</span>
        </button>
        <div css={css`
            overflow: hidden;
            height: ${ open ? `auto` : `0px` };
        `}>
          <RichText content={answer}></RichText>
        </div>
    </div>
  )
}

FAQItem.propTypes = {
    question: PropTypes.string,
    answer: PropTypes.array,
}

FAQItem.defaultProps = {
    question: 'Should I actually burn my candle?',
    answer: [
      {
          "_key": "3ea50ebfc390",
          "_type": "block",
          "children": [
              {
                  "_key": "323553faf1d0",
                  "_type": "span",
                  "marks": [],
                  "text": "Of course you should!"
              }
          ],
          "markDefs": [],
          "style": "normal"
      }
  ],
}

export default FAQItem
